/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { AnyAction } from 'redux';
import { SET_SCREEN_CONTROLLER, SET_SCREEN_TASK_CONTROLLER } from './screens.types';

export const setScreenControllerAction = (
    screenController: string,
    previousScreenController: string,
): AnyAction => ({
    type: SET_SCREEN_CONTROLLER,
    payload: {
        screenController,
        previousScreenController,
    },
});

export const setScreenTaskControllerAction = (
    screenTaskController: string,
    previousScreenTaskController: string,
): AnyAction => ({
    type: SET_SCREEN_TASK_CONTROLLER,
    payload: {
        screenTaskController,
        previousScreenTaskController,
    },
});
